<template>
    <v-layout
        row
    >
        <v-flex
            class="pa-2 ma-1"
        >
            <breadcrumbs
                :items="breadcrumbsItems"
            ></breadcrumbs>
            <v-card-title>Outlets</v-card-title>
            <v-row>
                <v-col cols="6">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        class="ma-1"
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col style="text-align: right;" class="pr-12">
                    <v-btn class="ma-1"
                           small
                           color="success"
                           @click="create()"> + Add Outlet
                    </v-btn>
                </v-col>
            </v-row>
            <div>
                <v-data-table
                    :headers="headers"
                    item-key="name"
                    :items="Object.values(outlets)"
                    :search="search"
                    dense
                    class="display-3 font-weight-medium"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-icon
                            class="mr-8"
                            @click="edit(item)"
                        >
                            mdi-pencil
                        </v-icon>
                        <v-icon
                            color="red"
                            @click="deleteOutlet(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                    <template v-slot:item.links="{ item }">
                        <div
                        >
                            <v-card-text>https://qms.aptsys.com.sg/outlet/{{ item.id }}/onsite</v-card-text>
                        </div>
                    </template>
                </v-data-table>
            </div>
        </v-flex>
    </v-layout>
</template>

<script>
import axios from "axios";

export default {
    name: 'outlets',
    props: ['outlets'],
    data: () => ({
        headers: [
            {
                text: 'Outlet',
                align: 'start',
                value: 'name',
            },
            {
                text: 'Description',
                value: 'description',
            },
            {
                text: 'Onsite Link',
                value: 'links'
            },
            {
                text: 'Actions',
                value: 'actions',
                sortable: false
            }
        ],
        search: null,
        breadcrumbsItems: '',
    }),
    methods: {
        create() {
            window.location.href = 'outlet/create'
        },
        edit(o) {
            window.location.href = 'outlet/' + o.id + '/edit'
        },
        deleteOutlet(o) {
            const i = this.outlets.indexOf(o);
            if (confirm('Are you sure you want to delete this outlet?')) {
                axios.delete('/outlet/' + o.id).then(response => {
                    this.outlets.splice(i, 1);
                });
            }
        },
    },
    beforeMount() {
        this.breadcrumbsItems = [
            {
                disabled: false,
                href: '/',
                link: true,
                text: 'Home',
            },
            {
                disabled: true,
                href: '#',
                link: true,
                text: 'Outlets',
            },
        ];
    }
}
</script>

<style>
.v-data-table-header th {
    white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Outlets/Outlets.vue